/* eslint-disable class-methods-use-this */
type StorageChangeListener = (key: string, newValue: any, oldValue: any) => void;

export default class LocalStorageManager {
  private listeners: Map<string, StorageChangeListener> = new Map();

  constructor() {
    window.addEventListener('storage', this.handleStorageEvent.bind(this));
  }

  private handleStorageEvent(event: StorageEvent) {
    const { key, newValue, oldValue } = event;
    const listener = this.listeners.get(key);
    if (listener) {
      listener(key, JSON.parse(newValue), JSON.parse(oldValue));
    }
  }

  setItem(key: string, value: any, triggerEvent: boolean = false) {
    const oldValue = localStorage.getItem(key);
    localStorage.setItem(key, JSON.stringify(value));
    if (oldValue !== JSON.stringify(value) && triggerEvent) {
      this.triggerChangeEvent(key, value, JSON.parse(oldValue));
    }
  }

  getItem(key: string) {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  }

  removeItem(key: string, triggerEvent: boolean = false) {
    localStorage.removeItem(key);
    if (triggerEvent) {
      this.triggerChangeEvent(key, null, JSON.parse(localStorage.getItem(key)));
    }
  }

  private triggerChangeEvent(key: string, newValue: any, oldValue: any) {
    const listener = this.listeners.get(key);
    if (listener) {
      listener(key, newValue, oldValue);
    }
  }

  addChangeListener(key: string, listener: StorageChangeListener) {
    this.listeners.set(key, listener);
  }

  removeChangeListener(key: string) {
    this.listeners.delete(key);
  }
}
